module.exports = __webpack_public_path__ + "static/media/icon-headset-outline.e48d99ed.svg";